import styled, { css } from 'styled-components';
import { getTextStyle } from '../content/texts/bou-text/text-style';
import { getTitleStyle } from '../content/texts/bou-title/title-style';
import { BouColor } from '../global/bou-colors';
import { BouSpacingLevel, fluidPadding, fluidSpacing } from '../layout/bou-spacing';
import { tabletOrWider } from '../layout/breakpoint-utils';
import CloseModalCrossSvg from './close-modal-cross.svg';

export const ModalSectionTitle = styled.div`
  color: ${BouColor.TOOL_TEXT_BLACK};
  ${getTitleStyle({ size: 'h7', withMargin: true })}
`;

export const ModalParagraph = styled.div`
  color: ${BouColor.TOOL_TEXT_BLACK};
  ${getTextStyle({ size: 'xxs', isBold: false, withMargin: true })}
`;

export const ModalExampleBox = styled.div`
  ${getTextStyle({ size: 'xxs' })}
  color: ${BouColor.TOOL_TEXT_BLACK};
  ${fluidPadding(BouSpacingLevel.TINY)}
  ${fluidSpacing('margin-top', BouSpacingLevel.MICRO)}
  border: 2px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
`;

export const ModalSection = styled.div`
  ${fluidSpacing('margin-top', BouSpacingLevel.TINY)}
`;

export const CloseButton = styled(CloseModalCrossSvg)`
  cursor: pointer;
  z-index: 9999;
  position: absolute;
  right: 0.5em;
  top: 0.5em;
  ${getTextStyle({ size: 'medium' })};
  width: 2.25em;
  height: 2.25em;
  ${tabletOrWider(css`
    width: 1.75em;
    height: 1.75em;
  `)}
`;
